/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type OptionType = any;

export const getOptionLabel = (option: OptionType): string => option as string;

export const getOptionAriaLabel = (option: OptionType): string =>
  option as string;

export const optionKeyGenerator = (option: OptionType, index: number): string =>
  `${option}__${index}`;
